export default __webpack_public_path__ + "static/media/model-attribute-mobile-part-2-new.9a504cfb.png";